import * as React from 'react';
import type { FieldValues, UseControllerProps, UseFormGetValues, UseFormUnregister } from 'react-hook-form';

import EditModeCellWrapper from './EditModeCellWrapper';
import TextArea from '../RHFFieldWrappers/TextArea/TextArea';
import TextAreaField from '../RHFFieldWrappers/TextArea/TextAreaField';

type Props<T extends FieldValues> = UseControllerProps<T> & {
	rhfId: string | number;
	onChange: (name: string) => void;
	unregister: UseFormUnregister<T>;
	getValues: UseFormGetValues<T>;
	fieldsLength: number;
};

function TextAreaCellRenderer<T extends FieldValues>(props: Props<T>) {
	const { rhfId, control, name, defaultValue, onChange, unregister, getValues, fieldsLength } = props;

	return (
		<EditModeCellWrapper name={name}>
			{(shouldBeRegistered, exitEditMode) =>
				shouldBeRegistered ? (
					<TextAreaField
						control={control}
						defaultValue={defaultValue}
						fieldsLength={fieldsLength}
						key={name}
						name={name}
						onBlur={exitEditMode}
						onChange={onChange}
						rhfId={rhfId}
						unregister={unregister}
					/>
				) : (
					<TextArea
						control={control}
						defaultValue={defaultValue}
						getValues={getValues}
						key={name}
						name={name}
						rhfId={rhfId}
					/>
				)
			}
		</EditModeCellWrapper>
	);
}

export default React.memo(TextAreaCellRenderer) as typeof TextAreaCellRenderer;
